/**
 * feat-300 — footprint #2 in `QuestionCard` (design NOTES §2): the slot after
 * the 🎉 line. Renders the thread panel when it is open, and the history lines
 * for closed threads.
 *
 * Renders nothing on a translated column (AT-12) and nothing without a
 * `QuestionEditProvider`.
 */
import React from 'react';
import { QuizQuestion } from '../../../../services/quizContentAdminService';
import { Column } from '../shared';
import { useQuestionEdit } from './QuestionEditProvider';
import ThreadPanel from './ThreadPanel';
import HistoryLines from './HistoryLines';

const QuestionEditThread: React.FC<{ q: QuizQuestion; index: number; column: Column }> = ({
  q,
  index,
  column,
}) => {
  const ctx = useQuestionEdit();
  if (!ctx || column !== null) return null;
  const open = ctx.isPanelOpen(q.id);
  // A thread closed in this session stays on its open panel until Hide, and
  // only then becomes a history line (NOTES §3.7).
  const onPanel = open ? ctx.panelThreadFor(q.id) : null;
  return (
    <>
      {open && <ThreadPanel q={q} index={index} />}
      <HistoryLines q={q} exclude={onPanel ? onPanel.id : null} />
    </>
  );
};

export default QuestionEditThread;
